var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { create } from "zustand";
import { userDataStore } from "./userDataStore";
export var useProfileSettings = create(function (set) { return ({
    isOpen: false,
    nickname: "",
    username: "",
    description: "",
    socialLinks: {},
    avatarFile: null,
    bannerFile: null,
    bannerUI: "",
    avatarUI: "",
    openModal: function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var user = userDataStore.getState().user;
        set({
            isOpen: true,
            nickname: ((_a = user === null || user === void 0 ? void 0 : user.profile) === null || _a === void 0 ? void 0 : _a.nickname) || "",
            username: ((_b = user === null || user === void 0 ? void 0 : user.profile) === null || _b === void 0 ? void 0 : _b.username) || "",
            description: ((_c = user === null || user === void 0 ? void 0 : user.profile) === null || _c === void 0 ? void 0 : _c.description) || "",
            socialLinks: {
                website: ((_d = user === null || user === void 0 ? void 0 : user.profile) === null || _d === void 0 ? void 0 : _d.website) || "",
                instagram: ((_e = user === null || user === void 0 ? void 0 : user.profile) === null || _e === void 0 ? void 0 : _e.instagram) || "",
                discord: ((_f = user === null || user === void 0 ? void 0 : user.profile) === null || _f === void 0 ? void 0 : _f.discord) || "",
                twitter: ((_g = user === null || user === void 0 ? void 0 : user.profile) === null || _g === void 0 ? void 0 : _g.twitter) || "",
                telegram: ((_h = user === null || user === void 0 ? void 0 : user.profile) === null || _h === void 0 ? void 0 : _h.telegram) || "",
                reddit: ((_j = user === null || user === void 0 ? void 0 : user.profile) === null || _j === void 0 ? void 0 : _j.reddit) || "",
            },
            avatarFile: null,
            avatarUI: ((_k = user === null || user === void 0 ? void 0 : user.profile) === null || _k === void 0 ? void 0 : _k.profilePictureImg) || null,
            bannerUI: ((_l = user === null || user === void 0 ? void 0 : user.profile) === null || _l === void 0 ? void 0 : _l.profileBannerImg) || null,
            bannerFile: null,
        });
    },
    closeModal: function () {
        set({ isOpen: false });
    },
    setNickname: function (v) { return set({ nickname: v }); },
    setUsername: function (v) { return set({ username: v }); },
    setDescription: function (v) { return set({ description: v }); },
    setSocialLink: function (key, val) {
        return set(function (state) {
            var _a;
            return ({
                socialLinks: __assign(__assign({}, state.socialLinks), (_a = {}, _a[key] = val, _a)),
            });
        });
    },
    setImg: function (file, value) {
        if (value === "banner") {
            if (!file)
                return set({ bannerFile: null, bannerUI: null });
            set({ bannerFile: file, bannerUI: URL.createObjectURL(file) });
            return;
        }
        if (value === "avatar") {
            if (!file)
                return set({ avatarFile: null, avatarUI: null });
            set({ avatarFile: file, avatarUI: URL.createObjectURL(file) });
            return;
        }
    },
    resetForm: function () {
        var user = userDataStore.getState().user;
        set({
            socialLinks: {
                website: "",
                instagram: "",
                discord: "",
                twitter: "",
                telegram: "",
                reddit: "",
            },
        });
    },
}); });
